import styled from "styled-components";

export type IStyledAppInput = {
    iconStart?: any;
    multiple?: boolean;
};

export const StyledAppInput = styled.div<IStyledAppInput>`
    width: 100%;
    .input {
      &__wrapper {
        width: 100%;
        .MuiOutlinedInput-root {
                background-color: ${(p) => p.theme.colors.white02};
                border-radius: 50px;
                font-family: ${(p) => p.theme.fontFamily.NotoSansJP_400};
                height: ${(p) => (p.multiple ? "22rem" : "4rem")};
                min-height: 40px;
                font-size: 16px;
                color: ${(p) => p.theme.colors.black01};
                padding-left: ${(p) => (p.iconStart ? "0px" : "10px")};
                border: none;

                .Mui-disabled {
                    border-radius: 0;
                    border-right: 1px solid rgba(0, 0, 0, 0.26);
                    margin-right: 2px;
                }
                .MuiOutlinedInput-input {
                    border: none;
                }

                &:hover {
                    fieldset: {
                        border-color: "yellow";
                    }
                }
            }
            &__label {
                text-align: left;
                padding-bottom: 5px;
                color: ${(p) => p.theme.colors.gray1};
                font-size: 14px;
            }
        }
    }
`;
export const Error = styled.span`
    text-align: left;
    font-size: 12px;
    color: ${(p) => p.theme.colors.error};
    padding-top: 5px;
    font-family: ${(p) => p.theme.fontFamily.NotoSansJP_500};
    font-weight: 500;
`;
